import { useMemo, useCallback } from 'react';
import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useDocuments from '../useDocuments';
import { getCompanyDocumentViewSections } from '../companyDocumentViewSections';

const ViewSection = ({ title, fields }) => (
  <List
    header={<div>{title}</div>}
    style={{ marginTop: 24 }}
    dataSource={fields}
    renderItem={(item) => (
      <List.Item>
        <b className={styles.itemName}>{item.text}</b>
        {item.value}
      </List.Item>
    )}
  />
);

const Single = () => {
  const { t } = useTranslation();
  const { singleItem, loading, handleDownloadPdf } = useDocuments(false);

  const onDownloadFile = useCallback(
    (url, fileName) => {
      handleDownloadPdf(url, fileName);
    },
    [handleDownloadPdf],
  );

  const sections = useMemo(
    () =>
      getCompanyDocumentViewSections(t, singleItem, { onDownloadFile }),
    [t, singleItem, onDownloadFile],
  );

  const pageTitle = singleItem?.title || t('DOCUMENTO');

  return (
    <div>
      <PageHeader title={pageTitle} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          {sections.map((section) => (
            <ViewSection
              key={section.title}
              title={section.title}
              fields={section.fields}
            />
          ))}
        </Spin>
        <Divider />
        <Row gutter={16}>
          {singleItem?.can_update !== false && (
            <Col>
              <Button>
                <Link
                  to={`/documents/company_documents/${singleItem?.id}/edit`}
                >
                  {t('MODIFICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/documents/company_documents'}>
                {t('TORNA INDIETRO')}
              </Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Single;
